// pages/public/Home.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Users, ArrowRightLeft, Search, Bus } from 'lucide-react';
import PublicLayout from '../../layouts/PublicLayout';

const Home = () => {
  const navigate = useNavigate();

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  const [formData, setFormData] = useState({
    origen: '',
    destino: '',
    fechaIda: '',
    pasajeros: 1
  });

  const [origenSugerencias, setOrigenSugerencias] = useState([]);
  const [destinoSugerencias, setDestinoSugerencias] = useState([]);
  const [showOrigenSugerencias, setShowOrigenSugerencias] = useState(false);
  const [showDestinoSugerencias, setShowDestinoSugerencias] = useState(false);

  const ciudades = [
    { id: 1, nombre: "Ciudad Bolívar", estado: "Bolívar" },
    { id: 2, nombre: "Puerto Ordaz", estado: "Bolívar" },
    { id: 3, nombre: "San Félix", estado: "Bolívar" },
    { id: 4, nombre: "Upata", estado: "Bolívar" },
    { id: 5, nombre: "Guasipati", estado: "Bolívar" },
    { id: 6, nombre: "El Callao", estado: "Bolívar" },
    { id: 7, nombre: "Tumeremo", estado: "Bolívar" },
    { id: 8, nombre: "Santa Elena de Uairén", estado: "Bolívar" },
    { id: 9, nombre: "Kavak", estado: "Bolívar" },
    { id: 10, nombre: "San Ignacio de Yuruaní", estado: "Bolívar" },
    { id: 11, nombre: "El Paují", estado: "Bolívar" },
    { id: 12, nombre: "Ciudad Guayana", estado: "Bolívar" },
    { id: 13, nombre: "Maturín", estado: "Monagas" },
    { id: 14, nombre: "El Tigre", estado: "Anzoátegui" },
    { id: 15, nombre: "San Tomé", estado: "Anzoátegui" },
    { id: 16, nombre: "Cantaura", estado: "Anzoátegui" },
    { id: 17, nombre: "Anaco", estado: "Anzoátegui" },
    { id: 18, nombre: "Barcelona", estado: "Anzoátegui" },
    { id: 19, nombre: "Puerto La Cruz", estado: "Anzoátegui" },
    { id: 20, nombre: "Lechería", estado: "Anzoátegui" },
    { id: 21, nombre: "Cumaná", estado: "Sucre" },
    { id: 22, nombre: "Carúpano", estado: "Sucre" },
    { id: 23, nombre: "Porlamar", estado: "Nueva Esparta" },
    { id: 24, nombre: "La Asunción", estado: "Nueva Esparta" },
    { id: 25, nombre: "Caracas", estado: "Distrito Capital" },
    { id: 26, nombre: "Maracay", estado: "Aragua" },
    { id: 27, nombre: "Valencia", estado: "Carabobo" },
    { id: 28, nombre: "Barquisimeto", estado: "Lara" },
    { id: 29, nombre: "Maracaibo", estado: "Zulia" },
    { id: 30, nombre: "Boa vista", estado: "Roraima - Brasil" },
  { id: 31, nombre: "Manaos", estado: "Amazonas - Brasil" }
  ];

  const filtrarCiudades = (texto) => {
    if (!texto) return [];
    return ciudades
      .filter(ciudad =>
        ciudad.nombre.toLowerCase().includes(texto.toLowerCase()) ||
        ciudad.estado.toLowerCase().includes(texto.toLowerCase())
      )
      .slice(0, 8);
  };

  const handleOrigenChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, origen: value });
    setOrigenSugerencias(filtrarCiudades(value));
    setShowOrigenSugerencias(value.length > 0);
  };

  const handleDestinoChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, destino: value });
    setDestinoSugerencias(filtrarCiudades(value));
    setShowDestinoSugerencias(value.length > 0);
  };

  const seleccionarOrigen = (ciudad) => {
    setFormData({ ...formData, origen: ciudad.nombre });
    setShowOrigenSugerencias(false);
  };

  const seleccionarDestino = (ciudad) => {
    setFormData({ ...formData, destino: ciudad.nombre });
    setShowDestinoSugerencias(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem('busquedaData', JSON.stringify(formData));
    navigate('/servicios');
  };

  const handleIntercambiar = () => {
    setFormData({
      ...formData,
      origen: formData.destino,
      destino: formData.origen
    });
  };

  return (
    <PublicLayout>
      <div className="container mx-auto px-4 min-h-[calc(100vh-200px)] flex items-center">
        <div className="max-w-4xl mx-auto w-full py-4">
          <div className="text-center mb-8">

            <h2 className="text-2xl font-light text-gray-700 mb-2">Busca tu pasaje</h2>
            <p className="text-gray-400 text-sm">Completa los datos para ver los horarios disponibles</p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
            <form onSubmit={handleSubmit} className="p-6">
              <div className="mb-6">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-3">
                  <div className="md:col-span-5 relative">
                    <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">
                      Origen
                    </label>
                    <input
                      type="text"
                      value={formData.origen}
                      onChange={handleOrigenChange}
                      onFocus={() => formData.origen && setShowOrigenSugerencias(true)}
                      onBlur={() => setTimeout(() => setShowOrigenSugerencias(false), 200)}
                      placeholder="Ciudad de origen"
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none transition-all text-sm bg-gray-50 hover:bg-white"
                      required
                      autoComplete="off"
                    />
                    {showOrigenSugerencias && origenSugerencias.length > 0 && (
                      <div className="absolute z-10 w-full mt-2 bg-white border border-gray-100 rounded-xl shadow-lg max-h-60 overflow-auto">
                        {origenSugerencias.map((ciudad) => (
                          <div
                            key={ciudad.id}
                            onClick={() => seleccionarOrigen(ciudad)}
                            className="px-4 py-3 hover:bg-pink-50 cursor-pointer border-b border-gray-50 last:border-0 transition-colors"
                          >
                            <div className="text-sm font-medium text-gray-800">{ciudad.nombre}</div>
                            <div className="text-xs text-gray-400">{ciudad.estado}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="md:col-span-2 flex items-end justify-center pb-1">
                    <button
                      type="button"
                      onClick={handleIntercambiar}
                      className="w-10 h-10 bg-pink-50 hover:bg-[#e83e8c] hover:text-white rounded-full flex items-center justify-center transition-all duration-200 hover:rotate-180 text-gray-600"
                    >
                      <ArrowRightLeft className="w-4 h-4" />
                    </button>
                  </div>

                  <div className="md:col-span-5 relative">
                    <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">
                      Destino
                    </label>
                    <input
                      type="text"
                      value={formData.destino}
                      onChange={handleDestinoChange}
                      onFocus={() => formData.destino && setShowDestinoSugerencias(true)}
                      onBlur={() => setTimeout(() => setShowDestinoSugerencias(false), 200)}
                      placeholder="Ciudad de destino"
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none transition-all text-sm bg-gray-50 hover:bg-white"
                      required
                      autoComplete="off"
                    />
                    {showDestinoSugerencias && destinoSugerencias.length > 0 && (
                      <div className="absolute z-10 w-full mt-2 bg-white border border-gray-100 rounded-xl shadow-lg max-h-60 overflow-auto">
                        {destinoSugerencias.map((ciudad) => (
                          <div
                            key={ciudad.id}
                            onClick={() => seleccionarDestino(ciudad)}
                            className="px-4 py-3 hover:bg-pink-50 cursor-pointer border-b border-gray-50 last:border-0 transition-colors"
                          >
                            <div className="text-sm font-medium text-gray-800">{ciudad.nombre}</div>
                            <div className="text-xs text-gray-400">{ciudad.estado}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">
                    Fecha de ida
                  </label>
                  <div className="relative">
                    <input
                      type="date"
                      min={getTodayDate()}
                      value={formData.fechaIda}
                      onChange={(e) => setFormData({ ...formData, fechaIda: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none text-sm bg-gray-50 hover:bg-white transition-all pr-10"
                      required
                    />
                    <Calendar className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">
                    Pasajeros
                  </label>
                  <div className="relative">
                    <select
                      value={formData.pasajeros}
                      onChange={(e) => setFormData({ ...formData, pasajeros: parseInt(e.target.value) })}
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none text-sm appearance-none bg-gray-50 hover:bg-white transition-all cursor-pointer pr-10"
                    >
                      {[1, 2, 3, 4, 5, 6].map(num => (
                        <option key={num} value={num}>{num} {num === 1 ? 'pasajero' : 'pasajeros'}</option>
                      ))}
                    </select>
                    <Users className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" />
                  </div>
                </div>
              </div>

              <button
                type="submit"
                className="w-full bg-[#e83e8c] hover:bg-[#c2185b] text-white py-3.5 rounded-xl text-sm font-medium transition-all duration-300 shadow-md hover:shadow-lg flex items-center justify-center gap-2"
              >
                <Search className="w-4 h-4" />
                Buscar pasajes
              </button>
            </form>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Home;